import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import StockDetail from "@/pages/StockDetail";
import Subscription from "@/pages/Subscription";
import Feed from "@/pages/Feed";
import StockPicker from "@/pages/StockPicker";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          {/* 总览：推送开关/手动触发/系统状态 + 订阅行情卡片 + 最近推送 */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/feed" element={<Feed />} />
          {/* 选股：多条件筛选沪深 A 股 */}
          <Route path="/picker" element={<StockPicker />} />
          <Route path="/stock/:code" element={<StockDetail />} />
        </Route>
      </Routes>
    </Router>
  );
}
